import { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/DashboardShell";
import { PrimaryButton } from "@/components/brand";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";

export default function ProfileSettings({ index = "05", showCompany = false }) {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "", phone: user?.phone || "", company_name: user?.company_name || "",
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { name: form.name, phone: form.phone };
      if (showCompany) payload.company_name = form.company_name;
      const { data } = await api.patch("/users/me", payload);
      setUser(data);
      toast.success("Profile updated");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Update failed");
    }
    setBusy(false);
  };

  return (
    <div>
      <PageHeader index={index} eyebrow="Settings" title="Profile & settings" />
      <form onSubmit={save} className="max-w-lg space-y-6 border border-gray-200 p-6" data-testid="profile-form">
        {showCompany && (
          <div>
            <label className="routa-label">Company name</label>
            <input data-testid="profile-company" value={form.company_name} onChange={set("company_name")} className="routa-input" />
          </div>
        )}
        <div>
          <label className="routa-label">Name</label>
          <input data-testid="profile-name" value={form.name} onChange={set("name")} className="routa-input" />
        </div>
        <div>
          <label className="routa-label">Email</label>
          <input value={user?.email || ""} disabled className="routa-input bg-gray-50 text-gray-400" />
        </div>
        <div>
          <label className="routa-label">Phone</label>
          <input data-testid="profile-phone" value={form.phone} onChange={set("phone")} className="routa-input" />
        </div>
        <PrimaryButton type="submit" disabled={busy} data-testid="profile-save">{busy ? "Saving…" : "Save changes"}</PrimaryButton>
      </form>
    </div>
  );
}
